/**
 * Shared axios client for the typed API modules. Re-exports the singleton
 * from `services/api.ts` so interceptors (bearer, X-Account-Id, 401) apply.
 */
import api from './instance'
import type { AxiosError } from 'axios'

export { api }
export const API_PREFIX = '/api/v1'

/** True when the error is an HTTP 404 (endpoint or resource missing). */
export function isNotFound(err: unknown): boolean {
  return (err as AxiosError | undefined)?.response?.status === 404
}

/** True for 404/501 — the backend has not shipped this contract yet. */
export function isUnimplemented(err: unknown): boolean {
  const s = (err as AxiosError | undefined)?.response?.status
  return s === 404 || s === 501 || s === 405
}

/**
 * Run a request and fall back to `fallback` when the endpoint is not
 * implemented yet. Other errors propagate.
 */
export async function withFallback<T>(fn: () => Promise<T>, fallback: T): Promise<T> {
  try {
    return await fn()
  } catch (err) {
    if (isUnimplemented(err)) return fallback
    throw err
  }
}
